const Sleep = {
  for: async (milliseconds: number) => {
    await new Promise((resolve) => setTimeout(resolve, milliseconds)); // eslint-disable-line
  },
};

export default Sleep;
